import {customElement, bindable} from "aurelia-framework";

@customElement('sio-pane')
export class Pane
{
    @bindable footer = null;
    @bindable addclasses = '';
}
